<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="rContents_toc_2"><a id="page_X"></a><a id="page_XI"></a><a href="#/xhtml/Contents#Contents_toc_2">acknowledgments</a></p>
<p class="noindent">The authors would like to thank VeloPress for having us back to write a second edition of this book. Special thanks to the editorial staff for their efforts in compiling and inserting the updated information, and to the artist, Joyce Turley, who beautifully transferred our exercise demonstration photos to illustrations.</p>
<p class="noindent-2"><i>From Ken:</i> I would like to thank my father, Mac, and my late mother, Judy, for always supporting me in my endeavors, be they athletic competitions or business ventures; they were always there for me. Deep gratitude to the many athletes of all levels whom I have coached over the years for keeping me sharp with their many questions and programming needs. Much appreciation to Brooke for her inspiration and gentle pushing to keep me on track in my many projects. And special thanks to my racing teammates and Dave Lettieri at Fastrack Bicycles for keeping me rolling all of these years.</p>
<p class="noindent-2"><i>From Eric:</i> I would like to thank my wife, Ingrid, and daughters, Hanna and Anya, for putting up with the long hours of computer work and piles of research material. I also thank my brother, Mark, who is a constant entrepreneurial inspiration. Thanks to my sister, Rebecca, for always looking on the lighter side of life. My mother, MaryAnn, deserves a special acknowledgment for the inspiring parental support she has provided over the years.<a id="page_XII"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgement.vue?053934cf